// extracted by mini-css-extract-plugin
export default {"questionContainer":"UawCard_questionContainer__RvtZX","question":"UawCard_question__xWLjc","horizontalContainer":"UawCard_horizontalContainer__R58fP","line":"UawCard_line__Alivt"};